import { DefaultPortion } from '../types';

// Default portions are still defined in Camasys Customer.
// Because the default portions are needed in SAP format, we need to translate them here.
// as soon as the default portions are defined in SAP, we can remove this entire helper
export const defaultPortions: ReadonlyArray<DefaultPortion> = [
  { id: 2, name: 'Small', description: 'Small (350g)' },
  { id: 1, name: 'Medium', description: 'Medium (450g)' },
  { id: 3, name: 'Large', description: 'Large (600g)' }
];

export const getDefaultPortion = (portionId: number | null | undefined) => {
  if (portionId === null || portionId === undefined) return null;
  return defaultPortions.find((portion) => portion.id === portionId) ?? null;
};
